import Handler from "./Handler";

// Tickets (Phase 7, admin backend /admin/tickets). Every call returns { ok, data, message }.
const BASE = "/admin/tickets";

const wrap = (response) => {
    if (response?.success) return { ok: true, data: response?.data?.data || {}, message: response?.data?.message || "" };
    return { ok: false, data: null, code: response?.data?.code, message: response?.data?.message || "Could not do that. Try again." };
};
const call = async (config) => wrap(await Handler({ ...config, silent: true }));

// A message with files goes as multipart; without, as normal (encrypted) JSON.
const send = (url, fields, files = []) => {
    if (!files.length) return call({ method: "post", url, data: fields });
    const form = new FormData();
    Object.entries(fields).forEach(([key, value]) => { if (value !== undefined && value !== null) form.append(key, value); });
    files.forEach((file) => form.append("files", file));
    return call({ method: "post", url, data: form, formdata: true });
};

export const ticketApi = {
    counts: () => call({ method: "get", url: `${BASE}/counts` }),
    queue: (queue, params) => call({ method: "get", url: `${BASE}/queue/${queue}`, params }),
    detail: (ticketId) => call({ method: "get", url: `${BASE}/${ticketId}` }),
    handlers: (search) => call({ method: "get", url: `${BASE}/handlers`, params: search ? { search } : {} }),
    take: (ticketId) => call({ method: "post", url: `${BASE}/${ticketId}/take`, data: {} }),
    message: (ticketId, { body, internal, status }, files) => send(`${BASE}/${ticketId}/messages`, { body, internal: internal ? "true" : "false", ...(status ? { status } : {}) }, files),
    status: (ticketId, status, note) => call({ method: "post", url: `${BASE}/${ticketId}/status`, data: { status, ...(note ? { note } : {}) } }),
    resolve: (ticketId, message) => call({ method: "post", url: `${BASE}/${ticketId}/resolve`, data: { message } }),
    close: (ticketId, note) => call({ method: "post", url: `${BASE}/${ticketId}/close`, data: { note } }),
    priority: (ticketId, priority) => call({ method: "post", url: `${BASE}/${ticketId}/priority`, data: { priority } }),
    reassign: (ticketId, person, note) => call({ method: "post", url: `${BASE}/${ticketId}/assign`, data: { type: person.type, id: person.id, note } }),
    returnToPool: (ticketId, note) => call({ method: "post", url: `${BASE}/${ticketId}/return`, data: { note } }),
    decideAppeal: (ticketId, decision, to, note) => call({ method: "post", url: `${BASE}/${ticketId}/appeal`, data: { decision, to, note } }),
    reopen: (ticketId, reason) => call({ method: "post", url: `${BASE}/${ticketId}/reopen`, data: { reason } }),
    settings: () => call({ method: "get", url: `${BASE}/settings` }),
    saveCategory: (kind, category) => call({ method: "put", url: `${BASE}/settings/categories/${kind}`, data: category }),
    saveSla: (kind, rows) => call({ method: "put", url: `${BASE}/settings/sla/${kind}`, data: { rows } }),
    saveGeneral: (general) => call({ method: "put", url: `${BASE}/settings/general`, data: general }),
    reports: (params) => call({ method: "get", url: `${BASE}/reports`, params }),
};

export default ticketApi;
